import React from 'react';
import * as Sentry from '@sentry/react';
import { getLocalStorage, handleOpenEmail, setLocalStorage } from '../utils';
import { Button } from './UI/button';

interface FallbackProps {
  error: unknown;
}

// This component is used as the fallback UI for the error boundary
const FallbackComponent: React.FC<FallbackProps> = ({ error }) => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 font-montserrat">
      <div className="bg-white px-16 py-24 rounded-xl shadow-md text-center max-w-2xl">
        <h2 className="text-2xl font-semibold text-[#364152] mb-4">Oops! Something went wrong.</h2>
        <p className="text-[#364152] mb-12 pt-4">
          We're sorry, but an unexpected error has occurred. <br></br>Please try refreshing the
          page, or contact us in our messager or at{' '}
          <span
            className="text-[#2497B2] cursor-pointer underline underline-offset-4"
            onClick={handleOpenEmail}>
            support@drumroll.ai
          </span>{' '}
          if the problem persists.
        </p>

        <Button
          textColor="#fff"
          description=" Refresh Page"
          backgroundColor="#FD8F22"
          fontSize={16}
          fontWeight={600}
          heigh={50}
          border={8}
          handleClick={() => {
            const prevPage = getLocalStorage('prev-page') ?? 'new_file';
            if (prevPage == 'new_file') {
              window.open(`/${prevPage}`, '_self');
            } else {
              setLocalStorage('lastPageStored', prevPage);
              window.location.reload();
            }
          }}
          borderColor="#FD8F22"
          className={`drop-shadow__Login px-2`}
          borderSize="2px"
          full={true}
          removeDefaultSpaces={true}
        />
      </div>
    </div>
  );
};

export const ErrorPage: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => <FallbackComponent error={error} />}
      beforeCapture={(scope) => {
        scope.setTag('location', window.location.href);
      }}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
